import imagen1 from "../../../../../assets/shareFileEmail/1.jpeg"
import imagen2 from "../../../../../assets/shareFileEmail/2.jpeg"
import imagen3 from "../../../../../assets/shareFileEmail/3.jpeg"
import imagen4 from "../../../../../assets/shareFileEmail/4.jpeg"

const HowSendEmail = () => {
    return(
        <div className="space-y-4">
            <div className="border border-black rounded p-2 shadow-lg">
            <strong>1.-Da click en el boton verde para descargar</strong>
            <img src={imagen1} alt="imagen" />
            </div>
            <div className="border border-black rounded p-2 shadow-lg">
            <strong>2.-Guarda en tu dispositivo</strong>
            <img src={imagen2} alt="imagen" />
            </div>
            <div className="border border-black rounded p-2 shadow-lg">
            <strong>3.-Da click en compartir</strong>
            <img src={imagen4} alt="imagen" />
            </div>
            <div className="border border-black rounded p-2 shadow-lg">
            <strong>4.-Selecciona la aplicación en la que desea compartir </strong>
            <img src={imagen3} alt="imagen" />
            </div>
        </div>
    );
};

export default HowSendEmail;